import { render, staticRenderFns } from "./ServerPaginationList.vue?vue&type=template&id=a35dfa74"
import script from "./ServerPaginationList.vue?vue&type=script&lang=ts"
export * from "./ServerPaginationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports